import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';

// TODO: Improve a11y with better text appropriate to usage (example: loading cart spinner)

@Component({
    selector: 'cx-spinner',
    templateUrl: './spinner.component.html',
    imports: [CommonModule, I18nModule]
})
export class SpinnerComponent {
  constructor() {}
}
